import { Media } from "@omni/types/api/shared/bff/media.model";
import { cn } from "@omni/utils/styles";

import { Anchor } from "@/components/General/Anchor/anchor.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type DocumentationListProps = {
    docMap: Map<string, Media[]>;
};

export const DocumentationList = ({ docMap }: DocumentationListProps) => {
    const { t } = useGranite();

    const documents = docMap
        .entries()
        .toArray()
        .flatMap(([key, documents], docMapIndex) => {
            return documents.map((document, docIndex) => {
                return {
                    key: `document-${docMapIndex}-${docIndex}`,
                    href: document.url,
                    text: `${t(key)} ${documents.length > 1 ? documents.length : ""}`
                };
            });
        });

    return (
        <ul className={cn("tw:list-disc tw:mb-0 tw:pl-5")}>
            {documents.map(({ key, href, text }) => (
                <li key={key}>
                    <Anchor
                        href={href}
                        color={"link"}
                        className={cn("tw:p-0")}
                    >
                        {text}
                    </Anchor>
                </li>
            ))}
        </ul>
    );
};
